export const baseUrl = 'enrolments';
export const APP_NAME = 'Enrolment Management';
